import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import api, { apiError } from "@/lib/api";

export default function AboutAdmin() {
  const [sections, setSections] = useState(null);
  const [saving, setSaving] = useState("");

  const load = useCallback(
    () => api.get("/admin/about").then((r) => setSections(r.data)).catch((e) => toast.error(apiError(e))),
    []
  );

  useEffect(() => { load(); }, [load]);

  const update = (key, patch) => {
    setSections(sections.map((s) => (s.section_key === key ? { ...s, ...patch } : s)));
  };

  const save = async (sec) => {
    setSaving(sec.section_key);
    try {
      await api.put(`/admin/about/${sec.section_key}`, { title: sec.title, body: sec.body });
      toast.success(`"${sec.title}" saved`);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving("");
    }
  };

  return (
    <div data-testid="about-admin" className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold text-navy">About Page Content</h1>
        <p className="mt-1 text-sm text-muted-foreground">Edit the sections shown on the public About Us page. Save each section after editing.</p>
      </div>
      {!sections ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : (
        <div className="space-y-6">
          {sections.map((sec) => (
            <section key={sec.section_key} className="rounded-lg border border-border bg-white p-6 shadow-sm" data-testid={`about-edit-${sec.section_key}`}>
              <Label htmlFor={`about-title-${sec.section_key}`}>Section Title</Label>
              <Input
                id={`about-title-${sec.section_key}`}
                data-testid={`about-title-input-${sec.section_key}`}
                value={sec.title}
                onChange={(e) => update(sec.section_key, { title: e.target.value })}
                className="mt-1.5 mb-4"
              />
              <Label htmlFor={`about-body-${sec.section_key}`}>Section Content</Label>
              <Textarea
                id={`about-body-${sec.section_key}`}
                data-testid={`about-body-input-${sec.section_key}`}
                rows={5}
                value={sec.body}
                onChange={(e) => update(sec.section_key, { body: e.target.value })}
                className="mt-1.5"
              />
              <div className="mt-4 flex justify-end">
                <Button onClick={() => save(sec)} disabled={saving === sec.section_key} className="bg-navy text-cream hover:bg-navy-light" data-testid={`about-save-${sec.section_key}`}>
                  {saving === sec.section_key ? "Saving…" : "Save Section"}
                </Button>
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
